import React from "react";
import "./Checkbox.css";

const Checkbox = ({ id, label, checked, onChange, disabled, className = "", ...rest }) => {
  return (
    <label className={`checkbox-container ${disabled ? "disabled" : ""} ${className}`} htmlFor={id}>
      <input type="checkbox" id={id} checked={!!checked} onChange={onChange} disabled={disabled} {...rest} />
      <span className="checkmark" />
      <span className="checkbox-label">{label}</span>
    </label>
  );
};

export default Checkbox;
